<template>
  <v-dialog scrollable ref="detailDlg" v-model="dialog" max-width="700">
    <v-card>
      <v-toolbar color="primary" dense dark>
          <v-toolbar-title class="white--text"
            >Pratinjau Klaim Presensi
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
      </v-toolbar>
      <v-card-text class="py-5">
        <v-row>
          <v-col cols="12">
            <v-list>
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption grey--text"
                        >Waktu Presensi</v-list-item-subtitle
                      >
                      <div class="primary--text font-weight-bold">
                        {{ pVal(klaimPresensi, "wkt_presensi") | toDT }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>

                <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption grey--text"
                        >Nama</v-list-item-subtitle
                      >
                      <div class="" v-if="klaimPresensi">
                        {{ pVal(klaimPresensi.users, "nama") }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption grey--text"
                        >Skor Datang</v-list-item-subtitle
                      >
                      <div class="">
                        {{ pVal(klaimPresensi, "skor_datang") }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption grey--text"
                        >Skor Pulang</v-list-item-subtitle
                      >
                      <div class="">
                        {{ pVal(klaimPresensi, "skor_pulang") }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle class="caption grey--text"
                        >Keterangan</v-list-item-subtitle
                      >
                      <div class="">
                        {{ pVal(klaimPresensi, "keterangan") }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="my-3">
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" color="primary" dark depressed class=" mr-1">
          Tutup
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      klaimPresensi: null,
      dialog: false
    };
  },
  computed: {},
  activated() {},
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.klaimPresensi = { ...obj };
      this.dialog = true;
    }
  }
};
</script>
